class NotificationPopup extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()

    if (sessionStorage.getItem('notificationPopupClosed') != 'true') {
      this.parentElement.setAttribute('aria-hidden', 'false')
    }
  }

  setupListeners () {
    this.els?.close?.element.addEventListener('click', (e) => {
      this.parentElement.setAttribute('aria-hidden', 'true')
      sessionStorage.setItem('notificationPopupClosed', 'true')
    })
  }
}

if (!customElements.get('notification-popup')) {
  customElements.define('notification-popup', NotificationPopup)
}
